<template>
  <div class="m-1">
    <router-link
      class="py-3.5 px-6 rounded flex items-center"
      :to="route"
      style="width: 100%;"
    >
      <FontAwesomeIcon v-if="icon" size="lg" class="mr-6" :icon="icon" />
      <slot />
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NavigationItem",
  components: {},
  props: {
    route: {
      type: [String, Object],
      default: null
    },
    icon: {
      type: String,
      default: null
    }
  },
  computed: {},
  data() {
    return {
      import_to_file: ""
    };
  },
  created() {}
};
</script>

<style></style>
